import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { overlay } from './Reducers/Overlay.reducer';
import productFiltering from './Reducers/ProductFiltering.reducer';
import { productListing } from './Reducers/ProductListing.reducer';
import { search } from './Reducers/Search.reducer';
import { buyButton } from './Reducers/BuyButton.reducer';
import { login } from './Reducers/Login.reducer';
import materialCalculator from './Reducers/MaterialCalculator.reducer';
import userInfoSlice from './Reducers/UserInfo.reducer';
import { productPage } from './Reducers/ProductPage.reducer';
import { priceHistory } from './Reducers/PriceHistory.reducer';

const staticReducers = {
  cart,
  quickSearch,
  navigation,
  checkout,
  materialCalculator,
  myPage,
  overlay,
  productFiltering,
  productListing,
  search,
  buyButton,
  login,
  userInfo: userInfoSlice,
  productPage,
  priceHistory,
};

const rootReducer = combineReducers(staticReducers);

export const createReducer = (asyncReducers: any) => {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
